"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const footer_styles_1 = require("@/components/layouts/footer/footer.styles");
require("@/components/common");
const soojubm_png_1 = __importDefault(require("@/images/soojubm.png"));
require("@/components/common/avatar/domain/user-snippet");
require("@/components/common/button/semantics/social-links");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let Footer = class Footer extends lit_1.LitElement {
    /* eslint-disable lit-a11y/accessible-emoji -- ©는 이모지가 아니라 활자 기호이고,
       스크린리더가 "저작권"으로 그대로 읽는다. role=img로 감싸면 오히려 읽기가 나빠진다. */
    render() {
        return (0, lit_1.html) `
      <footer class="footer" id="footer" role="contentinfo">
        <figure hidden></figure>
        <mm-user-snippet
          name="수줍이"
          email="soojubm@gmail.com"
          phone="010 3121 7045"
          description="UI Designer"
          avatar-src=${soojubm_png_1.default}
          avatar-variant="secondary"
        ></mm-user-snippet>

        <div class="footer-links">
          <mm-social-links
            notion="https://soojubm.notion.site/UI-Designer-9c18f4dd39eb4181b9f9c2ee76896618"
            github="https://github.com/soojubm"
          ></mm-social-links>
        </div>

        <dl class="footer-address-info">
          <dt>상호</dt>
          <dd>주식회사 수줍당</dd>
          <dt>대표이사</dt>
          <dd>수줍이</dd>
          <div class="footer-address-break"></div>
          <dt>사업자등록번호</dt>
          <dd>888-88-88888</dd>
          <dt>주소</dt>
          <dd>서울시 강서구 까치산로 182, 1028호</dd>
          <dt>대표전화</dt>
          <dd>02-1234-5678</dd>
          <dt>통신판매업신고번호</dt>
          <dd>2018-서울강서구-1234</dd>
        </dl>
        <mm-caption>© 2019 soojubm. All rights reserved.</mm-caption>
        <address>
          <mm-paragraph size="large">Making things better.</mm-paragraph>
        </address>

        <mm-to-top-button></mm-to-top-button>
      </footer>
    `;
    }
};
Footer.styles = [shared_styles_1.resetStyles, footer_styles_1.footerStyles];
Footer = __decorate([
    (0, decorators_js_1.customElement)('mm-footer')
], Footer);
exports.Footer = Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9vdGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiZm9vdGVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7OztBQUFBLDZCQUFzQztBQUN0QyxxREFBaUQ7QUFFakQsNkVBQXdFO0FBQ3hFLCtCQUE0QjtBQUM1Qix1RUFBK0M7QUFDL0MsMERBQXVEO0FBQ3ZELDZEQUEwRDtBQUMxRCwrREFBeUQ7QUFHbEQsSUFBTSxNQUFNLEdBQVosTUFBTSxNQUFPLFNBQVEsZ0JBQVU7SUFHcEM7NkRBQ3lEO0lBQ3pELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7Ozs7Ozt1QkFRUSxxQkFBWTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0tBaUM5QixDQUFBO0lBQ0gsQ0FBQzs7QUEvQ00sYUFBTSxHQUFHLENBQUMsMkJBQVcsRUFBRSw0QkFBWSxDQUFDLENBQUE7QUFEaEMsTUFBTTtJQURsQixJQUFBLDZCQUFhLEVBQUMsV0FBVyxDQUFDO0dBQ2QsTUFBTSxDQWtEbEI7QUFsRFksd0JBQU0ifQ==